import { FaHome,FaRegBookmark,MdExplore,IoNotifications,FaUserCircle,FaBookmark } from "../components/icons"

export const sidebarMenu=[
                {path:"/home",Icon:<FaHome/>,name:"Home"},
                {path:"/explore",Icon:<MdExplore/>,name:"Explore"},
                {path:"/bookmark",Icon:<FaBookmark/>,name:"Bookmarks"},
                {path:"/profile",Icon:<FaUserCircle />,name:"Profile"}
];